module.exports = __webpack_public_path__ + "static/img/news2.1047283.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/news2.png
// module id = RoBG
// module chunks = 7